import type { SingleSelectCardsProps } from '../../types';

export default function SingleSelectCards({
  options,
  value,
  onChange,
  className = '',
  compact = false,
}: SingleSelectCardsProps & { compact?: boolean }) {
  // Determine if options are simple (no icons, no descriptions) for compact styling
  const isSimple = options.every(opt => !opt.icon && !opt.description);
  const useCompact = compact || isSimple;

  return (
    <div className={`single-select-grid ${className}`}>
      {options.map((option) => {
        const isSelected = value === option.id;

        return (
          <button
            key={option.id}
            type="button"
            className={`selectable-card ${isSelected ? 'selectable-card--selected' : ''} ${useCompact ? 'selectable-card--compact' : ''}`}
            onClick={() => onChange(option.id)}
          >
            {option.icon && (
              <span className="selectable-card__icon">{option.icon}</span>
            )}
            <div className="selectable-card__content">
              <span className="selectable-card__title">{option.title}</span>
              {option.description && (
                <span className="selectable-card__description">{option.description}</span>
              )}
            </div>
            <span className="selectable-card__indicator" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
